import React from 'react';

import { COMMON_OFFERS } from '@sravni/ugc/lib/specialOffers/lists';

import type { IShortOrganization } from '../../../../../../../interfaces/organizations';
import type { ProductTermFromBff } from '../../../../../../../types/offers';
import { Bankruptcy } from '../../types/Bankruptcy/Bankruptcy';
import { Common } from '../../types/Common/Common';
import { Loan } from '../../types/Loan/Loan';

export interface MainBlockProps {
  activeTabType: any;
  bankName: string;
  logoBlock: JSX.Element;
  conditions: ProductTermFromBff[];
  labelFromAdvertising: string;
  organization: IShortOrganization;
  rating: number;
  reviewCount: number;
  isMobile: boolean;
  item: any;
  isWithButtons: boolean;
  offerTitle: string;
  handleOfferTitleClick?: () => void;
}

export const MainBlock = ({
  activeTabType,
  bankName,
  logoBlock,
  conditions,
  labelFromAdvertising,
  organization,
  rating,
  reviewCount,
  isMobile,
  item,
  isWithButtons,
  offerTitle,
  handleOfferTitleClick,
}: MainBlockProps) => {
  if (activeTabType.type === COMMON_OFFERS.loan) {
    return <Loan bankName={bankName} logoBlock={logoBlock} conditions={conditions} label={labelFromAdvertising} />;
  }
  if (activeTabType.type === COMMON_OFFERS.bankrotstvo) {
    return (
      <Bankruptcy
        activeTabType={activeTabType}
        organization={organization}
        bankName={bankName}
        rating={rating}
        reviewCount={reviewCount}
        logoBlock={logoBlock}
        isMobile={isMobile}
        itemId={item._id}
        conditions={conditions}
        isWithButtons={isWithButtons}
      />
    );
  }
  return (
    <Common
      activeTabType={activeTabType}
      bankName={bankName}
      logoBlock={logoBlock}
      isMobile={isMobile}
      itemId={item._id}
      conditions={conditions}
      isWithButtons={isWithButtons}
      offerTitle={offerTitle}
      handleOfferTitleClick={handleOfferTitleClick}
    />
  );
};
